module.exports = __webpack_public_path__ + "media/images/wfc/city-8-ea120108086461588458a7d3d414413a.jpg";